// JsFromRoutes CacheKey 25fc9c7aed05db75a9d2a71689ea32f3
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  redirectFromShortUrl: /* #__PURE__ */ definePathHelper('get', '/c/:external_id(/:click_code)'),
  updateInvitations: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/invitations'),
  updateReminders: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/reminders'),
  updateGiftRecipients: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events/:id/gift_recipients'),
  index: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/events'),
  create: /* #__PURE__ */ definePathHelper('post', '/consumer/calendar/events'),
  show: /* #__PURE__ */ definePathHelper('get', '/consumer/calendar/events/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/consumer/calendar/events/:id'),
}
